module.exports = __webpack_public_path__ + "img/11_sustainableCitiesAndCommunities.7686c019.png";